import Component from '@glimmer/component';
import { reads } from '@ember/object/computed';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';

export default class MwBadge extends Component {
  @service account;
  @service dynamicDialogs;

  @reads('args.owner') owner;

  get isVerified() {
    if (this.args.isVerified) return true;
    if (this.args.postedByPage) return this.args.page?.isVerified;

    return this.owner?.badges?.verified;
  }

  get isPremium() {
    if (this.args.postedByPage) return false;
    if (this.args.isPremium) return true;

    return this.owner?.badges?.premium;
  }

  get isDonor() {
    if (this.args.postedByPage) return false;
    if (this.args.isDonor) return true;

    return this.owner?.badges?.donor;
  }

  get isFavorite() {
    if (this.args.postedByPage) return false;

    const isFavorite = this.args.isFavorite || this.isUserFavorite(this.owner?.id);
    return !this.args.ignoreFavorite && isFavorite;
  }

  get levelBadge() {
    if (this.args.postedByPage) return false;

    if (this.args.levelBadge) {
      return this.args.levelBadge;
    }

    if (this.owner?.badges?.level4) return 4;
    if (this.owner?.badges?.level3) return 3;
    if (this.owner?.badges?.level2) return 2;
    if (this.owner?.badges?.level1) return 1;
    return null;
  }

  get noBadgesToDisplay() {
    return !this.isVerified && !this.isPremium && !this.isDonor && !this.isFavorite && !this.levelBadge && !this.args.isAmbassador;
  }

  isUserFavorite(userId) {
    return this.account.favorites?.includes(userId);
  }

  @action
  openBadgesInfoDialog(e) {
    if (this.args.nonClickable) return;

    // usually there is some other action in parent element/component
    // if badge is clickable then other actions should be prevented
    e.stopPropagation();
    e.preventDefault();

    this.dynamicDialogs.openDialog('about-badges-dialog', {
      user: this.args.owner || this.args.ambassador,
      isVerified: this.args.isVerified || this.args.postedByPage,
    });
  }
}
